// extracted by mini-css-extract-plugin
export default {"moreInfoBtn":"moreInfo_moreInfoBtn__yLWic","moreInfoIcon":"moreInfo_moreInfoIcon__Cieto"};